import React from 'react';
import { useQuery } from 'react-query';

import { Box, Grid, Typography } from '@material-ui/core';

import VehicleCards from '../../../../components/VehicleCards/VehicleCards.component';
import VehicleList from '../../../../components/VehicleList/VehicleList.component';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../../../query/vehicles/vehicles';

const WhichVehicle = () => {
  const { updateSinisterBody, nextStep } = useSinisterDataContext();

  const { data: vehicles } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );

  const handleNextStep = (vehicle: any) => {
    updateSinisterBody({
      can_request_assistance: vehicle.can_request_assistance,
      vehicle_id: vehicle.id,
      vehicle_brand: vehicle.brand,
      vehicle_model: vehicle.model,
    });
    nextStep();
  };

  const vehiclesToShow =
    vehicles?.filter((vehicle: any) => vehicle.policy.status === 'active') ||
    [];

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography variant="h6">
              {/* <Typography variant="h6" color="primary"> */}
              ¿Qué vehículo sufrió el siniestro?
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {vehiclesToShow.length > 10 ? (
            <Grid container justify="center" alignItems="center">
              <Grid item xs={11}>
                <VehicleList
                  setFunction={handleNextStep}
                  verified
                ></VehicleList>
              </Grid>
            </Grid>
          ) : (
            <Grid container justify="center" alignItems="center">
              <Grid item xs={11}>
                <VehicleCards
                  setFunction={handleNextStep}
                  verified
                ></VehicleCards>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default WhichVehicle;
